// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2RtSh","fileBtn":"File_fileBtn__3Ea9T","closeBtn":"File_closeBtn__gUl-6","fileSelected":"File_fileSelected__3zieZ","disabled":"File_disabled__ntNIe"};